import {ResolvedCloudArtifact} from '@mintdata-wsp/common/state/ui/visualDesigner/VisualDesignerState';

export interface ICloudComponentsLoader
{
    loadAndResolveAllCloudArtifacts():Promise<ResolvedCloudArtifact[]>;
}

export class EmptyCloudComponentLoader implements ICloudComponentsLoader
{
    public loadAndResolveAllCloudArtifacts():Promise<ResolvedCloudArtifact[]>
    {
        return Promise.resolve([]);
    }
}
